import classes from './sceCpcCheckbox.scss';

const Checkbox = function (props) {
    let spanFocus = '0';
    let inputFocus = '-1';
    if (props.focusOnCheckBoxIcon) {
        spanFocus = '-1';
        inputFocus = '0';
    }
    let checkBoxLabelElement, border, checkBoxStyle, formContainerBorder;
    let isChecked = props.selectedOptions;

    const handleKeyPress=(event)=>{ 
        if(event.which===32 || event.which===13){
            props.handleClick();  
            event.preventDefault();
        }
    };

    if (props.type === 'simpleCheckBox') {
        checkBoxLabelElement =  <span className='sr-only'>{props.id}</span>;
        checkBoxStyle = classes.sceCheckboxSimple;
    }
    // Transparent Background for simple checkbox, used in Move center module.
    else if(props.type === 'moveCenterCheckBox'){
        checkBoxLabelElement = <span className='sr-only'>{props.id}</span>;
        checkBoxStyle = classes.sceCheckboxMoveCenter;
    }
    else {
        border = props.selectedOptionIcon ? classes.successBorder : null;
        checkBoxStyle = props.isSelectAllCheck ? classes.sceSelectAllCheck : classes.sceCheckbox;
        formContainerBorder = classes.defaultBorder;
        checkBoxLabelElement = props.options;
    }

    // const validStatusIcon = props.selectedOptionIcon ? <span className={classes.sceCheckIcon}>
    //  <i aria-hidden className="fas fa-check-circle fa-lg" />
    // </span> : null;

    // const hintIcon = props.showHintIcon ?
    //  <a title='Open Section' aria-label="Show Hint" role='button' href='#' tabIndex="0" onClick={props.toggleHintText} className={classes.sceBtnStyle}>
    //      <span>
    //          <i aria-hidden className={"far fa-question-circle fa-2x "+classes.sceFontColorWhite+" " +classes.sceRightBtnIcon} />
    //      </span>
    //  </a> : null;

    // const hintMessageJSX = props.showHintMessage ? <div className={classes.infotipContainer}>
    //  <div className={classes.infotipContent}>{props.hintMessage}</div>
    // </div> : null;

    return (
        // <div className={classes.sceFormContainer + ' ' + formContainerBorder}>
        <div>
            <div className={'sce-checkbox '+checkBoxStyle + ' ' + border} >
                <input checked={isChecked} onClick={props.handleClick} type="checkbox" id={props.id} disabled={props.disabled} />
                <label htmlFor={props.id}  onKeyPress={(event)=>handleKeyPress(event)} className="sce-checkBox-text" >{checkBoxLabelElement}</label>
                {/* {validStatusIcon} */}
            </div>
        </div>
            // {hintIcon}
            // <div>{hintMessageJSX}</div>
        // </div>
    );
};
export default Checkbox;
